import { boundClass } from 'autobind-decorator';
import EventEmitter from 'eventemitter3';
import { SubscriptionStatus } from './UserTracker/types';

type User = {
  id: string;
  firstName: string;
  lastName: string;
};

export interface UserContextInterface {
  getUserId(): string;
  setUserId(newUserId: string);
  getUser(): User;
  setUser(user: User);
  getSubscriptionStatus(): SubscriptionStatus;
  getOrganizationId(): string;
  setOrganizationId(newOrganizationId: string);
  setSubscriptionStatus(newSubscription: SubscriptionStatus);
  getEventEmitter(): EventEmitter;
}

@boundClass
class UserContext implements UserContextInterface {
  private userId: string;
  private organizationId: string;
  private user: User;
  private eventEmitter: EventEmitter;
  private subscriptionStatus: SubscriptionStatus;

  constructor(EventEmitterContructor = EventEmitter) {
    this.eventEmitter = new EventEmitterContructor();
  }

  getUserId(): string {
    return this.userId;
  }

  setUserId(newUserId: string) {
    this.userId = newUserId;
    this.eventEmitter.emit('user-changed', newUserId);
  }

  setSubscriptionStatus(newSubscription: SubscriptionStatus) {
    this.subscriptionStatus = newSubscription;
    this.eventEmitter.emit('subscription-status-changed', newSubscription);
  }

  getOrganizationId(): string {
    return this.organizationId;
  }

  getSubscriptionStatus(): SubscriptionStatus {
    return this.subscriptionStatus;
  }

  setOrganizationId(newOrganizationId: string) {
    this.organizationId = newOrganizationId;
    this.eventEmitter.emit('organization-changed', newOrganizationId);
  }

  getUser(): User {
    return this.user;
  }

  setUser(user: User) {
    this.user = user;
  }

  getEventEmitter() {
    return this.eventEmitter;
  }
}

export default UserContext;
